export default __webpack_public_path__ + "static/media/logo.d99a44da.svg";